<a (click)="openEmailClient()" appDebounceClick appRequireLogin class="w-100">
  <i class="fas fa-envelope font-size-base fa-2x icon-size"></i>
  <span class="venture__actions-label">
    {{ 'UI.Common.Email' | translate }}
  </span>
</a>
